import { getFormattedDateRange } from '@lmt/unicorn-shared/app/components/patients/common';
import { RPDF } from './common/react-pdf';
import React from 'react';
import { ReportLogo } from './svg/ReportLogo';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

interface Props {
  startDate: Date;
  endDate?: Date;
}

export const ReportHeader: React.FC<Props> = (props) => {
  const i18next = useScopedTranslation('calendar.report');
  return (
    <RPDF.View fixed style={RPDF.styles.headerContainer}>
      <RPDF.Text style={RPDF.styles.headerText}>
        {i18next.t('title', {
          date: getFormattedDateRange(props.startDate, props.endDate),
        })}
      </RPDF.Text>
      <ReportLogo />
    </RPDF.View>
  );
};
